import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import LoanPropertyListUI from './LoanPropertyListUI.js'

class LoanPropertyListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      propertyList: null,
      updateMode: false,
      selectedProperty: null
    }
  }

  render() {
    let filteredList = this.props.propertyList ? this.props.propertyList.filter(p => p.category === this.props.category) : []
    return (
      <LoanPropertyListUI
        context={this.props.context}
        errorList={this.state.errorList}
        propertyList={filteredList}
        selectedProperty={this.state.selectedProperty}
        updateMode={this.state.updateMode}
        category={this.props.category}
        categoryLabel={this.props.categoryLabel}
        loan={this.props.loan}
        // events
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onUpdate={this.onUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProperties(context)
  }

  getProperties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.loan.loanId}/properties`,
      cacheKey: CacheKeys.LoanProperties(this.props.loan.loanId),
      callback: this.getPropertiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPropertiesCallback = (response) => {
    this.setState({errorList: response.errorList, propertyList : response.loanPropertyList})
  }

  onUpdateClick = (event) => {
    let propertyCode = event.currentTarget.getAttribute('data-property')
    console.log(propertyCode);
    let selectedProperty = this.state.propertyList.filter(p => p.propertyCode === propertyCode)[0]
    this.setState({updateMode: true, selectedProperty: selectedProperty})
  }

  onCancelClick = () => {
    this.setState({updateMode:false, errorList: null})
  }

  onUpdate = (selectedProperty) => {
    CacheManager.removeObject(CacheKeys.LoanProperties(this.props.loan.loanId))
    this.setState({propertyList : this.state.propertyList})
  }

  onRefreshClick = (noBusy) => {
    CacheManager.removeObject(CacheKeys.LoanProperties(this.props.loan.loanId))
    if (noBusy === 'noBusy') {
      console.log('noBusy');
      this.getProperties(this.props.context)
    }
    else {
      this.setState(
        {
          propertyList: null,
          errorList: null,
        }, this.getProperties(this.props.context)
      )
    }
  }
}

export default LoanPropertyListSF
